import React from 'react';
import MDDashboardV2 from './MDDashboardV2';

function App() {
  return <MDDashboardV2 />;
}

export default App;
